// in src/posts.js
import React, { Component } from 'react';
import {BooleanField, ImageField, ImageInput, DeleteButton, BooleanInput, ShowButton, DateField, RichTextField, Show, SimpleShowLayout, SimpleList, Filter, List, Edit, Create, Datagrid, ReferenceField, TextField, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import Dropzone from 'react-dropzone'
import inputUploadField from '../mui/field/UploadField';
import InputUploadInput from '../mui/field/UploadInput';
import { RichTextInput } from 'ra-input-rich-text';
import onDrop from '../mui/field/onDrop';
import { useMediaQuery } from '@mui/material';

//Utils
import Validators from './renderFields/validatorsFields';

const infoMessage = (
    <div style={{ marginBottom: '16px', color: 'gray' }}>
      Solo se permiten formatos de imagen PNG.
    </div>
);

const PayprizeFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="idsection" alwaysOn />
    </Filter>
);

export const PayprizeList = (props) => {
    // Check if the screen size is small
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List {...props} title="Listar Reclamar Premios" filters={<PayprizeFilter />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => `Reclamar Premios ${record.idsection}`}
                    secondaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="idsection" label="ID Sección" />
                    <ImageField source="cover" label="Portada" />
                    <RichTextField source="descriptions" label="Descripción" />
                    <EditButton />
                    <ShowButton />
                    <DeleteButton />
                </Datagrid>
            )}
        </List>
    );
};

export const PayprizeEdit = (props) => (
    <Edit title="Editar Reclamar Premios" {...props}>
        <SimpleForm>
            <TextInput source="id" disabled/>
            <TextInput source="idsection" label="ID Sección" validate={[Validators.required, Validators.number]}/>
            <InputUploadInput source="cover" label="Portada" validate={[Validators.required, Validators.fileExtension]}/>
            {infoMessage}
            <RichTextInput source="descriptions" label="Descripción" isRequired={true} validation={{ required: true }}/>
        </SimpleForm>
    </Edit>
);

export const PayprizeCreate = (props) => (
    <Create {...props} title="Crear Reclamar Premios">
        <SimpleForm >
            <TextInput source="idsection" label="ID Sección" validate={[Validators.required, Validators.number]}/>
            <InputUploadInput source="cover" label="Portada" validate={[Validators.required, Validators.fileExtension]}/>
            {infoMessage}
            <RichTextInput source="descriptions" label="Descripción" isRequired={true} validation={{ required: true }}/>
        </SimpleForm>
    </Create>
);

export const PayprizeShow = (props) => (
    <Show title="Ver Reclamar Premios" {...props}>
        <SimpleShowLayout>
            <TextField source="idsection" label="ID Sección"/>
            <ImageField source="cover" label="Portada"/>
            <RichTextField source="descriptions" label="Descripción"/>
            <DateField label="Fecha de Actualización" source="updatedAt" />
            <DateField label="Fecha de Publicación" source="createdAt" />
        </SimpleShowLayout>
    </Show>
);
